import React from 'react'
import { Loader } from '@web/walter-ui-kit'

import styles from './style.module.css'

export function Preloader() {
    return (
        <div className={styles.tab}>
            {Array.from({ length: 2 }).map((_, idx) => (
                <div key={idx} className={styles.level}>
                    <div className={styles.title}>
                        <Loader width={75} height={22} />
                    </div>

                    {Array.from({ length: 3 }).map((_, index) => (
                        <div key={index} className={styles.info}>
                            <Loader width={130 + index * 10} height={18} />
                            <Loader width={100 - index * 10} height={18} />
                        </div>
                    ))}
                </div>
            ))}
        </div>
    )
}
